import * as moment from 'moment';
import * as _ from 'lodash';
import { Component } from 'react';
import { Utility } from '@nkr/services/utility';
import { connect, Dispatch } from 'react-redux';
import { AdpDonorActionCreators, AppActionCreators, DonorActionCreators, IAddVoucherHolderResponse, IApplicationState, IAppState, IDonorAliasResponse, IVoucherHolderFileUploadResponse, IVoucherHolderLookupDataResponse, IVoucherHolderResponse } from '@nkr/store/index';
import { IAdpVoucherHolderRequest, IBaseResponse, IListItem } from '@nkr/models/index';
import { AboType, AdpVoucherHolderStatus, Country } from '@nkr/enums/index';
import { VoucherHolderAction } from '../voucher-holder-action';
import UploadModal from '../modals/upload-modal';
import OrderKitConfirmationModal from '../modals/order-kit-confirmation-modal';
import { toast } from 'react-toastify';
import SwapDonorsNav from '@nkr/views/donors/swap-donors/nav';
import { IAddEditData } from './add-edit-data';
import { IValidation } from './validation';
import AddEditForm from './add-edit-form';

interface IProps {
    voucherHolderId: number,
    centerId: number,
    donorId: number,
    isAdmin: boolean,
    isAdminLogin: boolean,
    onLoaded?: (name: string) => void
}

interface IStateProps {
    app: IAppState
}

interface IDispatchProps {
    showLoading: (message?: string) => Promise<void>,
    hideLoading: () => void,
    getVoucherHolderById: (voucherHolderId: number) => Promise<IVoucherHolderResponse>,
    getVoucherHolderLookupData: () => Promise<IVoucherHolderLookupDataResponse>,
    getDonorAliasById: (id: number) => Promise<IDonorAliasResponse>,
    addVoucherHolder: (donorId: number, request: IAdpVoucherHolderRequest) => Promise<IAddVoucherHolderResponse>,
    updateVoucherHolder: (id: number, request: IAdpVoucherHolderRequest) => Promise<IBaseResponse>,
    uploadVoucherHolderConsentForm: (voucherHolderId: number, consentFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    uploadVoucherHolderSwabResults: (voucherHolderId: number, swabResultsFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    uploadVoucherHolderScreeningResults: (voucherHolderId: number, screeningResultsFile: File) => Promise<IVoucherHolderFileUploadResponse>,
    orderHlaKit: (voucherHolderId: number) => Promise<IBaseResponse>,
    resendLink: (voucherHolderId: number) => Promise<IBaseResponse>,
    reorderScreening: (voucherHolderId: number) => Promise<IBaseResponse>,
}

type TProps = IStateProps & IDispatchProps & IProps;

interface IState {
    id: number,
    data: IAddEditData,

    donorId: number,
    donorAlias: string,

    validation: IValidation,

    dirty: boolean,

    upload: {
        show: boolean,
        type: VoucherHolderAction
    },
    orderKit: {
        show: boolean,
        type: VoucherHolderAction
    },

    aboTypeList: IListItem[],
    ckdStatusList: IListItem[],
    voucherHolderStatusList: IListItem[],
    voucherHolderTypeList: IListItem[],
    genderList: IListItem[],
    countryList: IListItem[],
}

class VoucherHolderAddEdit extends Component<TProps, IState> {
    readonly state: IState = {
        id: 0,
        data: {
            abo: AboType.Unknown,
            ckdStatus: 0,
            status: AdpVoucherHolderStatus.Available,
            type: 0,
            gender: 0,
            firstName: '',
            lastName: '',
            country: Country.UnitedStates,
            addressLine1: '',
            addressLine2: '',
            city: '',
            stateProvince: '',
            postalCode: '',
            phoneNumberPrimary: '',
            phoneNumberSecondary: '',
            emailPrimary: '',
            emailSecondary: '',
            birthDate: ''
        },

        donorId: 0,
        donorAlias: '',

        validation: {
            type: true,
            gender: true,
            firstName: true,
            lastName: true,
            country: true,
            addressLine1: true,
            city: true,
            stateProvince: true,
            postalCode: true,
            phoneNumberPrimary: true,
            emailPrimary: true,
            emailSecondary: true,
            birthDate: true
        },

        dirty: false,

        upload: {
            show: false,
            type: null
        },
        orderKit: {
            show: false,
            type: null
        },

        aboTypeList: [],
        ckdStatusList: [],
        voucherHolderStatusList: [],
        voucherHolderTypeList: [],
        genderList: [],
        countryList: [],
    }

    componentDidMount = () => {
        this.getData();
    }

    getData = () => {
        this.props.showLoading('Retrieving voucher holder, one moment please...').then(async () => {
            if (this.props.voucherHolderId > 0) {
                let voucherHolderResponse = await this.props.getVoucherHolderById(this.props.voucherHolderId);
                let lookupDataResponse = await this.props.getVoucherHolderLookupData();

                if (voucherHolderResponse.data.success && lookupDataResponse.data.success) {
                    let { abo, ckdStatus, status, type, gender, firstName, lastName, country,
                        addressLine1, addressLine2, city, stateProvince, postalCode,
                        phoneNumberPrimary, phoneNumberSecondary,
                        emailPrimary, emailSecondary, birthDate, donorId, donorAlias } = voucherHolderResponse.data.results;

                    let { aboTypeList, ckdStatusList, voucherHolderStatusList,
                        voucherHolderTypeList, genderList, countryList } = lookupDataResponse.data.results;

                    this.setState({
                        id: this.props.voucherHolderId,
                        data: {
                            abo, ckdStatus, status, type, gender, firstName, lastName, country,
                            addressLine1, addressLine2, city, stateProvince, postalCode,
                            phoneNumberPrimary, phoneNumberSecondary,
                            emailPrimary, emailSecondary, birthDate
                        },

                        donorId,
                        donorAlias,

                        aboTypeList, ckdStatusList, voucherHolderStatusList,
                        voucherHolderTypeList, genderList, countryList
                    }, () => {
                        this.props.onLoaded(this.state.data.firstName + ' ' + this.state.data.lastName);
                    });
                }
            } else {
                let donorAliasResponse = await this.props.getDonorAliasById(this.props.donorId);
                let lookupDataResponse = await this.props.getVoucherHolderLookupData();

                if (donorAliasResponse.data.success && lookupDataResponse.data.success) {
                    let donorAlias = donorAliasResponse.data.results;

                    let { aboTypeList, ckdStatusList, voucherHolderStatusList,
                        voucherHolderTypeList, genderList, countryList } = lookupDataResponse.data.results;

                    this.setState({
                        donorId: this.props.donorId,
                        donorAlias,

                        aboTypeList, ckdStatusList, voucherHolderStatusList,
                        voucherHolderTypeList, genderList, countryList
                    });
                }
            }

            this.props.hideLoading();
        });
    }

    validate = () => {
        let { type, gender, firstName, lastName, country, addressLine1, city, stateProvince, postalCode, phoneNumberPrimary, emailPrimary, emailSecondary, birthDate } = this.state.data;

        let validation: IValidation = {
            type: type > 0,
            gender: gender > 0,
            firstName: firstName != '',
            lastName: lastName != '',
            country: country >= 0,
            addressLine1: addressLine1 != '',
            city: city != '',
            stateProvince: stateProvince != '',
            postalCode: postalCode != '',
            phoneNumberPrimary: phoneNumberPrimary != '',
            emailPrimary: Utility.isValidEmail(emailPrimary),
            emailSecondary: emailSecondary != '' ? Utility.isValidEmail(emailSecondary) : true,
            birthDate: moment(birthDate, 'MM/DD/YYYY').isValid()
        };

        return validation;
    }

    isValid = () => {
        let { validation } = this.state;

        let isValid = validation.type && validation.gender && validation.firstName && validation.lastName && validation.country && validation.addressLine1
            && validation.city && validation.stateProvince && validation.postalCode && validation.phoneNumberPrimary && validation.emailPrimary
            && validation.emailSecondary && validation.birthDate;

        return isValid;
    }

    handleFieldChange = (field: string, value: any) => {
        let data = { ...this.state.data };

        if (field == 'abo' || field == 'ckdStatus' || field == 'status' || field == 'type' || field == 'gender') {
            data[field] = parseInt(value);
        } else {
            data[field] = value;
        }

        this.setState({
            data
        });
    }

    handleSave = () => {
        let validation = this.validate();

        this.setState({
            validation,
            dirty: true
        }, () => {
            if (this.isValid()) {
                let { abo, ckdStatus, status, type, gender,
                    firstName, lastName, country,
                    addressLine1, addressLine2, city, stateProvince, postalCode,
                    phoneNumberPrimary, phoneNumberSecondary,
                    emailPrimary, emailSecondary,
                    birthDate } = this.state.data;

                let isAdmin = this.props.isAdmin || this.props.isAdminLogin;

                let request = {
                    abo, ckdStatus, status, type, gender,
                    firstName, lastName, country,
                    addressLine1, addressLine2, city, stateProvince, postalCode,
                    phoneNumberPrimary, phoneNumberSecondary,
                    emailPrimary, emailSecondary,
                    birthDate,
                    isAdmin
                }

                this.props.showLoading('Saving voucher holder, one moment please...').then(async () => {
                    if (this.state.id > 0) {
                        let response = await this.props.updateVoucherHolder(this.state.id, request);

                        if (response.data.success) {
                            toast.success('Voucher holder updated successfully');
                        } else {
                            toast.error('Unable to save voucher holder: ' + response.data.message);
                        }
                    } else {
                        let response = await this.props.addVoucherHolder(this.state.donorId, request);

                        if (response.data.success) {
                            this.setState({
                                id: response.data.results
                            });

                            toast.success('Voucher holder added successfully');
                        } else {
                            toast.error('Unable to save voucher holder: ' + response.data.message);
                        }
                    }

                    this.props.hideLoading();
                });
            }
        });
    }

    handleCancel = () => {
        if (this.props.isAdmin) {
            window.location.href = '/admin/recipients/voucher-holders';
        } else {
            window.location.href = '/center/' + this.props.centerId + '/recipients/voucher-holders';
        }
    }

    handleAction = (eventKey: any) => {
        if (eventKey == VoucherHolderAction.ResendLink) {
            this.handleResendLink(this.props.voucherHolderId);
        }

        if (eventKey == VoucherHolderAction.OrderBuccalSwabKit || eventKey == VoucherHolderAction.OrderLabScreening) {
            this.setState({
                orderKit: {
                    show: true,
                    type: eventKey
                }
            })
        }

        if (eventKey == VoucherHolderAction.UploadVoucherConsent || eventKey == VoucherHolderAction.UploadSwabResults || eventKey == VoucherHolderAction.UploadScreeningResults) {
            this.setState({
                upload: {
                    show: true,
                    type: eventKey
                }
            })
        }
    }

    handleUpload = (file: File) => {
        let type = this.state.upload.type;
        let voucherHolderId = this.props.voucherHolderId;

        this.setState({
            upload: {
                show: false,
                type: type
            }
        }, () => {
            let success = true;
            let message = '';

            this.props.showLoading('Uploading file, one moment please...').then(async () => {
                if (type == VoucherHolderAction.UploadVoucherConsent) {
                    let response = await this.props.uploadVoucherHolderConsentForm(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                }

                if (type == VoucherHolderAction.UploadSwabResults) {
                    let response = await this.props.uploadVoucherHolderSwabResults(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                }

                if (type == VoucherHolderAction.UploadScreeningResults) {
                    let response = await this.props.uploadVoucherHolderScreeningResults(voucherHolderId, file);

                    success = response.data.success;
                    message = response.data.message;
                }

                this.props.hideLoading();

                if (success) {
                    toast.success('File uploaded successfully');
                } else {
                    toast.error('Unable to upload file: ' + message);
                }
            });
        });
    }

    handleCancelUpload = () => {
        this.setState({
            upload: {
                show: false,
                type: null
            }
        });
    }

    handleOrderKit = () => {
        let type = this.state.orderKit.type;
        let voucherHolderId = this.props.voucherHolderId;

        this.setState({
            orderKit: {
                show: false,
                type: VoucherHolderAction.OrderBuccalSwabKit
            }
        }, () => {
            let success = true;
            let message = '';

            this.props.showLoading('Submitting kit request, one moment please...').then(async () => {
                if (type == VoucherHolderAction.OrderBuccalSwabKit) {
                    let response = await this.props.orderHlaKit(voucherHolderId);

                    success = response.data.success;
                    message = response.data.message;
                }

                if (type == VoucherHolderAction.UploadSwabResults) {
                    let response = await this.props.reorderScreening(voucherHolderId)

                    success = response.data.success;
                    message = response.data.message;
                }

                this.props.hideLoading();

                if (success) {
                    toast.success('Kit request submitted successfully');
                } else {
                    toast.error('Unable to request kit: ' + message);
                }
            });
        });
    }

    handleResendLink = (id: number) => {
        this.props.showLoading("One moment please, resending voucher holder their registration")
            .then(() => {
                this.props.resendLink(id).then((request) => {
                    let { success, message } = request.data;

                    if (success) {
                        toast.success(message);
                    } else {
                        toast.error('Unable to resend link: ' + message);
                    }
                })
            })
            .finally(() => {
                this.props.hideLoading();
            })
    }

    handleCancelOrderKit = () => {
        this.setState({
            orderKit: {
                show: false,
                type: null
            }
        });
    }

    render = () => {
        const fullName = this.state.id > 0 ? this.state.data.firstName + ' ' + this.state.data.lastName : 'NEW';
        const isValid = this.isValid();

        return (
            <>
                {this.props.isAdmin == false &&
                    <SwapDonorsNav
                        activeKey='VOUCHER-HOLDER-EDIT'
                        centerId={this.props.centerId}
                        donorId={this.state.donorId}
                        donorAlias={this.state.donorAlias}
                        donorIsAdp={true}
                        voucherHolderId={this.state.id}
                        voucherHolderName={fullName}
                        recipientId={0}
                        recipientAlias={''}
                        recipientCenterId={0}
                        recipientType={null}
                        isAdminLogin={this.props.isAdminLogin}
                        onTabChange={() => null}
                    />
                }

                <div className='recipient-section'>
                    <AddEditForm
                        data={this.state.data}
                        voucherHolderId={this.props.voucherHolderId}
                        isAdmin={this.props.isAdmin}
                        isAdminLogin={this.props.isAdminLogin}
                        isValid={isValid}
                        validation={this.state.validation}
                        dirty={this.state.dirty}
                        genderList={this.state.genderList}
                        countryList={this.state.countryList}
                        aboTypeList={this.state.aboTypeList}
                        ckdStatusList={this.state.ckdStatusList}
                        voucherHolderStatusList={this.state.voucherHolderStatusList}
                        voucherHolderTypeList={this.state.voucherHolderTypeList}
                        showActions={true}
                        onAction={this.handleAction}
                        onFieldChange={this.handleFieldChange}
                        onSave={this.handleSave}
                        onCancel={this.handleCancel} />
                </div>

                <UploadModal
                    show={this.state.upload.show}
                    donorAlias={this.state.donorAlias}
                    voucherHolderFullName={this.state.data.firstName + ' ' + this.state.data.lastName}
                    type={this.state.upload.type}
                    isDonorProfile={false}
                    onUpload={this.handleUpload}
                    onCancel={this.handleCancelUpload}
                />

                <OrderKitConfirmationModal
                    show={this.state.orderKit.show}
                    donorAlias={this.state.donorAlias}
                    voucherHolderFullName={this.state.data.firstName + ' ' + this.state.data.lastName}
                    type={this.state.orderKit.type}
                    onConfirmed={this.handleOrderKit}
                    onCancel={this.handleCancelOrderKit}
                />
            </>
        );
    }
}

const mapStateToProps = (appState: IApplicationState): IStateProps => {
    return {
        app: appState.app,
    }
}

const mapDispatchToProps = (dispatch: Dispatch<IApplicationState>): IDispatchProps => {
    return {
        showLoading: (message) => {
            return dispatch(AppActionCreators.showLoadingAsync(message));
        },
        hideLoading: () => {
            dispatch(AppActionCreators.hideLoading());
        },
        getVoucherHolderById: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.getVoucherHolderById(voucherHolderId));
        },
        getVoucherHolderLookupData: () => {
            return dispatch(AdpDonorActionCreators.getVoucherHolderLookupData());
        },
        getDonorAliasById: (id) => {
            return dispatch(DonorActionCreators.getDonorAliasById(id));
        },
        addVoucherHolder: (donorId, request) => {
            return dispatch(AdpDonorActionCreators.addVoucherHolder(donorId, request));
        },
        updateVoucherHolder: (id, request) => {
            return dispatch(AdpDonorActionCreators.updateVoucherHolder(id, request));
        },
        uploadVoucherHolderConsentForm: (voucherHolderId, consentFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderConsentForm(voucherHolderId, consentFile));
        },
        uploadVoucherHolderSwabResults: (voucherHolderId, swabResultsFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderSwabResults(voucherHolderId, swabResultsFile));
        },
        uploadVoucherHolderScreeningResults: (voucherHolderId, screeningResultsFile) => {
            return dispatch(AdpDonorActionCreators.uploadVoucherHolderScreeningResults(voucherHolderId, screeningResultsFile));
        },
        orderHlaKit: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.orderHlaKit(voucherHolderId));
        },
        resendLink: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.resendVoucherLink(voucherHolderId))
        },
        reorderScreening: (voucherHolderId) => {
            return dispatch(AdpDonorActionCreators.reorderScreening(voucherHolderId));
        }
    };
}

export default connect<IStateProps, IDispatchProps, IProps>(
    mapStateToProps,
    mapDispatchToProps)(VoucherHolderAddEdit);